var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: _vm.collapsed },attrs:{"href":("#" + _vm.contentContainer),"title":"Expandir","role":"button","data-toggle":"collapse","data-parent":("#" + _vm.accordion)}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64be18a1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Collapse/CollapseTitle.vue
// module id = null
// module chunks = 